import { AccountInfo } from '@azure/msal-browser';

import { IdTokenClaims } from '../models';

/**
 * Gets email from account info.
 * @param account Account info to get email from.
 */
export const getEmailFromAccount = (account: AccountInfo): string => {
  const idTokenClaims = account.idTokenClaims as IdTokenClaims;

  return idTokenClaims?.email?.trim() || '';
};
